import type { Ref } from 'react';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { detectIfTruncated } from '../../common-functions';
import Input from '../../fields/input/input.component';
import TooltipLegacy from '../../tooltip-component/tooltip.component';
import type { DataGridDataCellBaseProps } from '../data-grid-settings.interface';

export type DataGridDataNumericalCellProps = DataGridDataCellBaseProps<string | number | bigint> & {
  isEditing?: boolean;
  width?: number;
};

function DataGridDataNumericalCell(
  { value, isEditing = false, width }: DataGridDataNumericalCellProps,
  forwardRef: Ref<HTMLDivElement>
) {
  const cellValue = value?.toString();
  const cellRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useImperativeHandle(forwardRef, () => cellRef.current as HTMLDivElement);

  useEffect(() => {
    if (cellRef.current) {
      setIsTruncated(detectIfTruncated(cellRef.current));
    }
  }, [width]);

  return isEditing ? (
    <Input type="number" name={cellValue} value={cellValue} />
  ) : (
    <TooltipLegacy
      description={cellValue}
      tooltipClassName="bg-mono-1"
      disabled={!isTruncated}
      tooltipZIndexCheck={true}
    >
      {/*  NOTE: if modifying the padding 'pl-2', please remember to update all other cells as well as 'CELL_PADDING_LEFT_PX' */}
      <div className="truncate pl-2" data-testid="data-grid-cell-content" ref={cellRef}>
        {cellValue}
      </div>
    </TooltipLegacy>
  );
}

export default forwardRef(DataGridDataNumericalCell);
